import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { ValidationProvider } from 'vee-validate';
import { FieldMixin } from '../mixins';

@Component({
    data() {
        return {
            optionValue: '',
            immediateValidation: false
        };
    },
    components: {
        ValidationProvider
    }
})

export default class AutocompleteField extends mixins(FieldMixin) {
    @Ref() autocomplete!: any;

    @Prop()
    value: string;

    optionValue;
    immediateValidation: boolean;

    mounted() {
        this.optionValue = this.value;
    }

    @Watch('value', { immediate: true })
    onChangeValue(value: string) {
        if (this.optionValue !== value && value) {
            this.optionValue = value;
            this.immediateValidation = true;
        }
    }

    @Watch('optionValue')
    changeSelection(value) {
        this.$emit('input', value);
    }
}
